import { Button } from '@bambi/component-library/src/components/Button/Button';
import { Popover } from '@bambi/component-library/src/components/Popover/Popover';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';
import {
  ChevronDownIcon,
  CloudArrowDownIcon,
} from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import {
  setAssignmentSearchTerm,
  setSelectedVehicle,
  setShowAssignmentExportModal,
  setShowAssignmentManagementModal,
  setShowMultiAssignmentManagementModal,
} from './assignmentManagement.slice';
import { AssignmentManagementBulkDeleteButton } from './AssignmentManagementBulkDeleteButton';
import { AssignmentManagementClearFiltersButton } from './AssignmentManagementClearFiltersButton';
import { AssignmentManagementDisplayToggle } from './AssignmentManagementDisplayToggle';

export function AssignmentManagementRouteActions() {
  const { isOwner, isBambi, isAdmin, isRestrictedSupport } = useUserRoles();
  const dispatch = useAppDispatch();

  const assignmentSearchTerm = useAppSelector(
    (state) => state.assignmentManagement.assignmentSearchTerm
  );

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setAssignmentSearchTerm,
    assignmentSearchTerm
  );

  const handleAddAssignment = () => {
    dispatch(setSelectedVehicle(undefined));
    dispatch(setShowAssignmentManagementModal(true));
  };

  const handleExportAssignmentClick = () => {
    dispatch(setShowAssignmentExportModal(true));
  };

  return (
    <>
      <AssignmentManagementBulkDeleteButton />
      <AssignmentManagementClearFiltersButton />
      <AssignmentManagementDisplayToggle />
      <SearchTypeahead
        onChange={handleInputChange}
        placeholder="Search crew schedules"
        value={inputValue}
      />
      {(isOwner || isBambi || isAdmin) && (
        <Button onClick={handleExportAssignmentClick}>
          <CloudArrowDownIcon className="mr-2 h-5 w-5" /> Download
        </Button>
      )}
      {!isRestrictedSupport && (
        <Popover
          trigger={
            <Button
              variant="primary"
              type="button"
              className="flex justify-between gap-2"
              dataTestId="add-assignments-button"
            >
              Add Crew Schedule
              <ChevronDownIcon className="h-4 w-4" />
            </Button>
          }
          content={
            <div className="flex flex-col gap-1">
              <Button
                onClick={() => handleAddAssignment()}
                variant="secondary"
                dataTestId="add-current-week-assignments"
              >
                Current Week Crew Schedule
              </Button>
              <Button
                onClick={() => {
                  dispatch(setSelectedVehicle(undefined));
                  dispatch(setShowMultiAssignmentManagementModal(true));
                }}
                variant="secondary"
                dataTestId="add-multi-assignments"
              >
                Recurring Crew Schedule
              </Button>
            </div>
          }
        />
      )}
    </>
  );
}
